import React, { PureComponent } from 'react';
import * as environmentService from '../../../utils/general/environmentService';
import * as HTML_RENDITION from '../../../utils/general/general';
import $ from 'jquery';
import { RSCH_HTML_TRACKING_CONFIG } from '../../../readership/trackingConfig';
import { connect } from 'react-redux';
import { IReducerState } from '../../../states/renditionStates';
import commonStore from '../../../store/commonStore.js';
import * as commonStateAction from '../../../actions/commonStateAction';
import personIconbig from '../../../../style/img/Person-Icon-big.png';
import * as deviceInfoService from '../../../utils/general/deviceInfoService';
import RenditionUrlGenerator from '../../../utils/api/renditionUrlGenerator';

interface IAuthorProfileProps {
    initialData: any;
    mainSource: any;
    source: any;
    showPartialAuthors?: boolean;
    defaultAuthorsToShow?: number;
    serial: number;
    getAnalystInfo: (analystId: string) => {};
    currentAuthorID: string;
    currentAuthorName: string;
    index: number;
    showOldBranding: boolean;
}

export class AuthorProfile extends PureComponent<IAuthorProfileProps, any> {
    public ANALYST_NAME = React.createRef<HTMLDivElement>();
    constructor(props: IAuthorProfileProps) {
        super(props);
    }

    public selectAuthor = (event: any, authorName: string) => {
        $('#author_profiles li').removeClass('selected');
        $('#author_profiles a').attr('aria-expanded', 'false');
        $(event.target).parents('li').addClass('selected');
        const idx = $(event.target).parents('li').index() % 5;
        const seq = $('#profiles_slideshow').find('.selected').index();
        const selectedId = 'authorname' + seq;
        $('#' + selectedId).attr('aria-expanded', 'true');
        $('#authors .author_card').addClass('hide');
        $('#authors div[data-serial=' + seq + ']').removeClass('hide');
        const { analystId, displayName } = this.props.source;
        const analystInfo = this.props.mainSource.analystInfo;
        commonStore.dispatch(commonStateAction.currentAuthorName(displayName));
        commonStore.dispatch(commonStateAction.currentAuthorID(analystId));
        RSCH_HTML_TRACKING_CONFIG.trackAuthorImageClick(displayName, analystId, this.props.source.title);
        if (analystInfo && !(analystId in analystInfo)) {
            this.props.getAnalystInfo(analystId);
        }
    };

    /* Start for ADA */
    // Handle tab press to get author profile, when need move to next authors slide
    public calculateAuthorSlideOffset = (isNext: boolean) => {
        let eachSlideContainsAuthorCount = 5;
        let eachSlideWidth = eachSlideContainsAuthorCount * 65;

        const profilesSlideshowWidth = $("body").width() || 0;
        if (profilesSlideshowWidth < 370) {
            eachSlideContainsAuthorCount = 4;
            eachSlideWidth = eachSlideContainsAuthorCount * 65;
        }
        let currentLeftValue = parseInt($('#author_profiles').css('left'), 10);
        let currentSlide = Math.ceil(($('#author_profiles li.selected').index() + 1) / eachSlideContainsAuthorCount);
        const totalAuthors = $('#author_profiles li').length;
        const sumWidth = totalAuthors * 65; // 65 means photo width 43 plus its margin 22
        const authorSlidesCount = Math.ceil(totalAuthors / eachSlideContainsAuthorCount);
        if (isNext) {
            currentLeftValue = currentLeftValue - eachSlideWidth;
            currentSlide++;
            if (currentLeftValue <= -sumWidth) {
                currentLeftValue = 0;
                currentSlide = 1;
            }
        } else {
            currentLeftValue = currentLeftValue + eachSlideWidth;
            currentSlide--;
            if (currentLeftValue > 0) {
                currentLeftValue = -(authorSlidesCount - 1) * eachSlideWidth;
                currentSlide = authorSlidesCount;
            }
        }

        $('#author_profiles').css({
            left: currentLeftValue
        });

        const eq = (currentSlide - 1) * eachSlideContainsAuthorCount;

        $('#profiles_slideshow li').removeClass('selected');
        $('#profiles_slideshow li').eq(eq).addClass('selected');

        const seq = $('#profiles_slideshow').find('.selected').index();

        $('#authors .author_card').addClass('hide');
        $('#authors div[data-serial=' + seq + ']').removeClass('hide');

        commonStore.dispatch(commonStateAction.currentAuthorName(this.props.source.displayName));
        commonStore.dispatch(commonStateAction.currentAuthorID(this.props.source.analystId));
        setTimeout(() => {  // use the timeout to trigger the state change in redux
            if (this.props.mainSource.analystInfo && !(this.props.currentAuthorID in this.props.mainSource.analystInfo)) {
                this.props.getAnalystInfo(this.props.currentAuthorID);
            }
        }, 50);
    };

    public handleKeyDown = (event: any, cbFun: any) => {
        const key = event.keyCode || event.which;
        if (key === 13) { // Enter key
            return cbFun();
        }
        if (event.shiftKey && event.keyCode == 9) { // Shift key and Tab key
            const authorSequence = $(event.target).parents('li').index() + 1;
            if (authorSequence != 1 && authorSequence % 5 == 1) { // When move to previous authors slide
                this.calculateAuthorSlideOffset(false);
            }
        } else if (key === 9) { // Tab key
            const authorSequence = $(event.target).parents('li').index() + 1;
            if (authorSequence != 0 && authorSequence % 5 == 0) { // When move to next authors slide
                this.calculateAuthorSlideOffset(true);
            }
        }
    };
    /* End for ADA */

    public render() {
        const { source, serial, showOldBranding } = this.props;
        let image;
        if (source.photo)
            image = environmentService.getImagePath(source.photo);
        const defaultImg = personIconbig;
        if (!image) {
            image = defaultImg;
        }
        if (deviceInfoService.isDeviceScreenType()) { 
            if (image.includes("ir.citi.com/")) {
                image = image.replace("ir.citi.com/", "ir.citi.com/anph/");
            }  
            var ajaxPromise = RenditionUrlGenerator.URL_GENERATOR.generateAuthFileLinkPublicURL(image);
            ajaxPromise.done(function (result : any){
                if (result) {
                    image = result.url;
                }
            }.bind(this)); 
        }
        const isACAnalyst = function () {
            return source.authorRow && HTML_RENDITION.parseToBoolean(source.authorRow.isACAnalyst);
        };
        source.authorWithAC = source.displayName + (isACAnalyst() ? "(AC)" : "");
        const author_profile = source.analystId &&
            <div ref={this.ANALYST_NAME} data-entitlement="ANALYST_NAME" id={'authorImage' + serial} className="authorImage" data-name={source.analystId}>
                <a tabIndex={0} id={'authorname' + serial} aria-label={source.authorWithAC} onClick={(e) => this.selectAuthor(e, 'authorName')} role="link" aria-expanded={this.props.index === 0 ? 'true' : 'false'} onKeyDown={(e) => this.handleKeyDown(e, this.selectAuthor.bind(this, e, 'authorName'))}>
                    <img src={image} alt={source.authorWithAC} />
                </a>
                {
                    showOldBranding && <span className="author_block_indicate" role="img" aria-label="author block indicator"></span>
                }
            </div>;
        return (
            <li className="author_profile">
                {author_profile}
            </li>
        );
    }
}

const mapStateToProps = (state: IReducerState) => {
    return {
        currentAuthorID: state.commonStateReducer.currentAuthorID,
        currentAuthorName: state.commonStateReducer.currentAuthorName,
    };
};

export default connect(mapStateToProps)(AuthorProfile);
